/**
 * Visor de un tablero estatico: iframe aislado con selector de periodo
 */
import { Body, Box, Button, Flexbox, Heading, Select, TableLoader } from "codekit";
import { useEffect, useState } from "react";

import { useLazyGetContentQuery } from "../../libs/redux/slices/Paramgen/Dashestx/dashestxApiSlice";

/**
 * Renderiza el tablero estatico seleccionado
 * @param {Object} props Propiedades del componente
 * @param {Object} props.dashboard Tablero elegido en la galeria
 * @param {Function} props.onBack Vuelve a la galeria
 */
const Visordas = ({ dashboard, onBack }) => {
  const [periodo, setPeriodo] = useState(dashboard.VERPERXX || "");
  const [getContent, { data: html, isFetching, isError }] = useLazyGetContentQuery();

  useEffect(() => {
    getContent({ DASHIDXX: dashboard.DASHIDXX, VERPERXX: periodo });
  }, [dashboard.DASHIDXX, periodo, getContent]);

  const periodosOptions = (dashboard.PERIODOS || []).map((item) => ({ value: item, text: item }));

  //codekit Select entrega el contexto { option } en lugar de un evento nativo
  const handleChangePeriodo = (context) => setPeriodo(context.option.value);

  return (
    <Box spacing={4}>
      <Flexbox justifyContent="between" alignItems="center" gap={4}>
        <Heading variant="heading-6">{dashboard.DASHNOMX}</Heading>
        <Flexbox gap={2} alignItems="center">
          {periodosOptions.length > 1 && (
            <Select options={periodosOptions} value={periodo} onChangeValue={handleChangePeriodo} />
          )}
          <Button variant="secondary" size="m" type="button" icon="back-arrow" onClick={onBack}>
            Volver
          </Button>
        </Flexbox>
      </Flexbox>
      {isFetching && <TableLoader />}
      {isError && (
        <Body variant="body-2">No se pudo cargar el tablero de este periodo.</Body>
      )}
      {!isFetching && !isError && (
        //El HTML lo genera un tercero: sin allow-same-origin no alcanza cookies ni sesion de CIMA
        <iframe
          title={dashboard.DASHNOMX}
          srcDoc={html}
          sandbox="allow-scripts"
          style={{ width: "100%", height: "calc(100vh - 220px)", border: 0 }}
        />
      )}
    </Box>
  );
};

export default Visordas;
